const getOrCreateElementById = (id: string, tag?: string) => {
  let element: HTMLElement | null;

  element = document.getElementById(id);

  if (element) {
    return element;
  }

  if (!tag) {
    return null;
  }

  element = document.createElement(tag);
  element.id = id;

  return element;
};

export default getOrCreateElementById;
export { getOrCreateElementById };
